import { RouteObject } from 'react-router-dom';
import OnboardingRoute from './onboardingRoute';
import PublicLayout from '../pages/Layouts/PublicLayout/Index';
import OnboardingWizard from '../pages/User/Onboarding/Index';

const onboardingRoutes: RouteObject[] = [
    {
        path: '/guest',
        element: <PublicLayout />,
        children: [

            {
                path: 'onboarding',
                element: (
                    <OnboardingRoute>
                        <OnboardingWizard />
                    </OnboardingRoute>
                ),
            },
        ],
    },
];

export default onboardingRoutes;
